/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @author Viacheslav Smalenski
 * @version 1.28.0
 * @since 1.14.0
 */

enum EFormValidation {
    fieldEmail = 'field.email',
    fieldNotType = 'field.notType',
    fieldNumberMax = 'field.number.max',
    fieldNumberMin = 'field.number.min',
    fieldNumberPositive = 'field.number.positive',
    fieldNumberNonNegative = 'field.number.nonnegative',
    fieldNumberInteger = 'field.number.integer',
    fieldNumberNotNumber = 'field.number.notnumber',
    fieldEmailFormat = 'field.email.format',
    fieldTitleLong = 'field.title.long',
    fieldNameLong = 'field.name.long',
    fieldLinkLong = 'field.link.long',
    fieldTemplateNameLong = 'field.template.name.long',
    fieldPhoneFormat = 'field.phone.format',
    fieldPhoneCommonFormat = 'field.phone.common.format',
    fieldRequired = 'field.required',
    fieldLinkIncorrect = 'field.link.incorrect',
    fileCorrupted = 'file.corrupted',
    fileDataEmpty = 'file.data.empty',
    fileExist = 'file.exist',
    fileFormatIncorrect = 'file.format.incorrect',
    fileNotFound = 'file.not.found',
    fileRowsExceeded = 'file.rows.exceeded',
    fileSizeExceeded = 'file.size.exceeded',
    filesSizeExceeded = 'files.size.exceeded',
    fileDeleteFailed = 'file.delete.failed',
    fileNameTooLong = 'file.name.too.long',
    filesNameTooLong = 'files.name.too.long',
    fileUploadUnavailable = 'file.upload.unavailable',
}

export default EFormValidation;
